var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2188 48 48 37.3125 48 24C48 10.7812 37.2188 0 24 0C10.6875 0 0 10.7812 0 24C0 37.3125 10.6875 48 24 48ZM21 18V30C21 31.6875 19.5938 33 18 33C16.3125 33 15 31.6875 15 30V18C15 16.4062 16.3125 15 18 15C19.5938 15 21 16.4062 21 18ZM33 18V30C33 31.6875 31.5938 33 30 33C28.3125 33 27 31.6875 27 30V18C27 16.4062 28.3125 15 30 15C31.5938 15 33 16.4062 33 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.03355639c1cb2f9cbe14fb5f8ded57af.svg";
export { ForwardRef as ReactComponent };